const formatDate = (date, locale, options?: Intl.DateTimeFormatOptions) => {
  try {
    return (
      date &&
      new Intl.DateTimeFormat(`${locale}-CH`, {
        dateStyle: "medium",
        ...(options || {}),
      }).format(new Date(date))
    );
  } catch (e) {
    return null;
  }
};

export default formatDate;
